(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('ResourceLink', ResourceLink);

    ResourceLink.$inject = ['$resource'];

    function ResourceLink ($resource) {
        var resourceUrl =  'resource/round/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
